import request from '@/utils/request';

export function querySettleList(data) {
  return request({
    url: '/merchant/settle/findSettleList',
    method: 'post',
    data,
  });
}

export function queryIncomeDetail(data) {
  return request({
    url: '/merchant/income/detailList',
    method: 'post',
    data,
  });
}
// 获取商户下拉列表
export function queryMerchantList(params) {
  return request({
    url: '/merchant/info/getMerchantInfo',
    method: 'get',
    params,
  });
}
// 获取门店下拉列表
export function queryShopList(params) {
  return request({
    url: '/merchant/info/getShopInfo',
    method: 'get',
    params,
  });
}
